import {
  doordashLogo,
  uberLogo,
  grubhubLogo,
  vGrubsProviderLogo,
  chowNowLogo,
  gloriaLogo,
  deliveryLogo,
  eatstreetLogo,
  menufyLogo,
  localForYouLogo,
  nabeLogo,
  bytesLogo,
  vGrubsAILogo,
  kanekt365Logo,
  devourNowLogo,
} from '../assets';
import { Provider } from '../types/shared.types';
import { showsProviderIdentity } from './providerIdentity';

export const providerName = (
  p: Provider,
  options?: {
    withoutPos?: boolean;
  }
) => {
  switch (p) {
    case Provider.ubereats:
      return 'Uber Eats';
    case Provider.doordash:
      return 'DoorDash';
    case Provider.grubhub:
      return 'Grubhub';
    case Provider.vGrubs:
      return 'vGrubs';
    case Provider.chownow:
      return 'ChowNow';
    case Provider.gloriafood:
      return 'GloriaFood';
    case Provider.delivery:
      return 'Delivery.com';
    case Provider.eatstreet:
      return 'EatStreet';
    case Provider.menufy:
      return 'Menufy';
    case Provider.grubhubPos:
      return options?.withoutPos ? 'Grubhub' : 'Grubhub POS';
    case Provider.doordashPos:
      return options?.withoutPos ? 'DoorDash' : 'DoorDash POS';
    case Provider.localForYou:
      return 'Local For You';
    case Provider.nabe:
      return 'Nabe';
    case Provider.bytes:
      if (showsProviderIdentity()) {
        return 'Bytes AI';
      }
      return 'vGrubs AI';
    case Provider.kanekt365:
      if (showsProviderIdentity()) {
        return 'Kanekt 365';
      }
      return 'vGrubs AI';

    case Provider.vGrubsAI:
      return 'vGrubs AI';
    case Provider.devourNow:
      return 'DevourNow';
  }
};

export const providerLogo = (p: Provider, isOrder?: boolean) => {
  switch (p) {
    case Provider.ubereats:
      return uberLogo;
    case Provider.doordash:
      return doordashLogo;
    case Provider.grubhub:
      return grubhubLogo;
    case Provider.vGrubs:
      return vGrubsProviderLogo;
    case Provider.chownow:
      return chowNowLogo;
    case Provider.gloriafood:
      return gloriaLogo;
    case Provider.delivery:
      return deliveryLogo;
    case Provider.eatstreet:
      return eatstreetLogo;
    case Provider.menufy:
      return menufyLogo;
    case Provider.grubhubPos:
      return grubhubLogo;
    case Provider.doordashPos:
      return doordashLogo;
    case Provider.localForYou:
      return localForYouLogo;
    case Provider.nabe:
      return nabeLogo;
    case Provider.bytes:
      if (showsProviderIdentity()) {
        return bytesLogo;
      }
      return vGrubsAILogo;

    case Provider.kanekt365:
      if (showsProviderIdentity()) {
        return kanekt365Logo;
      }
      return vGrubsAILogo;
    case Provider.vGrubsAI:
      return vGrubsAILogo;
    case Provider.devourNow:
      return devourNowLogo;
  }
};

// Google returns the unit as often bare ("b", "106D") as labelled ("Suite 200"),
// and the backend prefixes the bare ones with "#" before it hands the address to
// a driver. Mirror that rule here so the app shows the same line the courier sees.
const UNIT_DESIGNATOR =
  /^(#|apt\b|apartment\b|suite\b|ste\b|unit\b|bldg\b|building\b|fl\b|floor\b|rm\b|room\b|space\b|spc\b|lot\b)/i;

export function formatUnitNumber(unitNumber?: string | null): string | null {
  const unit = (unitNumber ?? '').trim();
  if (!unit) return null;
  return UNIT_DESIGNATOR.test(unit) ? unit : `#${unit}`;
}

// "20010 FM 529" + "b" -> "20010 FM 529 #b". The unit never lives inside
// `address`, so it has to be glued on at render time.
export function addressWithUnitNumber(
  address?: string | null,
  unitNumber?: string | null
) {
  return [address, formatUnitNumber(unitNumber)].filter(Boolean).join(' ');
}
